import { useEffect, useState } from 'react';

export type GEO = {
  city?: string;
  country?: {
    code?: string;
    name?: string;
  };
  subdivision?: {
    code?: string;
    name?: string;
  };
  latitude?: number;
  longitude?: number;
  timezone?: string;
};

// const testGeo = {
//   city: 'Kyiv',
//   country: { code: 'DE', name: 'Ukraine' },
//   subdivision: { code: 'UA-30', name: 'Kyiv City' },
//   latitude: 50.4501,
//   longitude: 30.5234,
//   timezone: 'Europe/Kyiv',
// };

const useGeo = () => {
  const [geo, setGeo] = useState<GEO | null>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    let isActive = true;

    fetch(`${location.origin}/geolocation`, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Geolocation unavailable');
        return response.json();
      })
      .then((data) => {
        if (isActive) setGeo(data && typeof data === 'object' && !Array.isArray(data) ? data : null);
      })
      .catch(() => {
        if (isActive) setGeo(null);
      });

    return () => { isActive = false; };
  }, []);

  return geo;
};

export default useGeo;
